import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import debounce from 'lodash/debounce'
import { useAppState, useAppDispatch } from './Context'
import MapMarker from './MapMarker'
import UserMarker from './UserMarker'

const defaultMapCenter = {
  lat: 43.074585,
  lng: -75.284402,
}

const mapOptions = {
  maxZoom: 18,
  fullscreenControl: false,
  zoomControlOptions: {
    position: 8, // RIGHT_CENTER
  },
}

function Map({ apiKey }) {
  const dispatch = useAppDispatch()
  const { locations, mapVisible, userCoords } = useAppState()

  const apiIsLoaded = (map, maps) => {
    map.addListener(
      'bounds_changed',
      debounce(() => dispatch({ type: 'setMapBounds', payload: map.getBounds() }), 250)
    )

    maps.event.addDomListener(document.querySelector('.locations-map-container'), 'click', (e) => {
      if (!e.target.closest('.map-location')) {
        dispatch({ type: 'setSelectedLocation', payload: null })
      }
    })

    dispatch({ type: 'setMap', payload: map })
    dispatch({ type: 'setMaps', payload: maps })
  }

  return (
    <div className={`locations-map-container ${mapVisible ? 'locations-map-container--visible' : ''}`}>
      <div className="w-full">
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={defaultMapCenter}
          defaultZoom={8}
          options={mapOptions}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
        >
          {locations.map((location) => (
            <MapMarker key={location.id} location={location} lat={location.lat} lng={location.lng} />
          ))}

          {userCoords && <UserMarker lat={userCoords.lat} lng={userCoords.lng} />}
        </GoogleMapReact>
      </div>
    </div>
  )
}

Map.propTypes = {
  apiKey: PropTypes.string,
}

export default Map
